import { type HTMLArkProps, ark } from '@ark-ui/react';

import type { CalloutColor, Scale3 } from '../../lib/types';
import { cn } from '../../lib/utils';

type CalloutRootProps = Omit<HTMLArkProps<'div'>, 'color'> & {
	size?: Scale3;
	variant?: 'soft' | 'outline' | 'surface';
	color?: CalloutColor;
};

function CalloutRoot({
	className,
	size = '2',
	variant = 'soft',
	color = 'neutral',
	...props
}: CalloutRootProps) {
	return (
		<ark.div
			data-slot="callout"
			data-size={size}
			data-variant={variant}
			data-color={color}
			className={cn('pt-callout', className)}
			{...props}
		/>
	);
}

function CalloutIcon({ className, ...props }: HTMLArkProps<'div'>) {
	return <ark.div className={cn('pt-callout-icon', className)} {...props} />;
}

function CalloutText({ className, ...props }: HTMLArkProps<'p'>) {
	return <ark.p className={cn('pt-callout-text', className)} {...props} />;
}

const Callout = Object.assign(CalloutRoot, {
	Root: CalloutRoot,
	Icon: CalloutIcon,
	Text: CalloutText
});

export { Callout, type CalloutRootProps as CalloutProps };
